import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { Repository } from './utils/repository.js';
import VueSmoothScroll from 'vue-smooth-scroll';

Vue.config.productionTip = false

Vue.prototype.$repository = await Repository.build()

Vue.use(VueSmoothScroll);

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
